module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("Who’s Who")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yeats saw a fish")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("as a mysterious girl")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("which made the world seem")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("more fuckable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He wanted to follow her")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("home")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("after he killed her,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but, of course, did not.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Here’s the thing,”")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("says the brand spokesmodel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("waving her Diet Coke")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and sounding beleaguered")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("yet defiant,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“just do "), _c('span', {
    staticClass: "font-i"
  }, [_vm._v("you")]), _vm._v("”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48defab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011_Chapter004.vue
// module id = 87
// module chunks = 0